export default __webpack_public_path__ + "static/media/spr-schema-2-dark-large.c385be12.png";